import { z } from 'zod/v4';

/**
 * A single structured event emitted by a sync phase, buffered in the cache and
 * flushed in batches to `amfori_sync_step_logs`. Phase runners (sub-tasks 3–9)
 * append these; the orchestrator never inspects their contents.
 *
 * - `status` — coarse outcome of the step (`OK` / `WARN` / `ERROR`).
 * - `code` — stable machine-readable identifier for the event.
 * - `message` — human-readable summary.
 * - `suggestedFix` — optional remediation hint surfaced to the user.
 * - `context` — optional structured payload (stored as jsonb).
 */
export const AmforiSyncStepLogStatusSchema = z.enum(['OK', 'WARN', 'ERROR']);

export type AmforiSyncStepLogStatus = z.infer<
  typeof AmforiSyncStepLogStatusSchema
>;

export const AmforiSyncStepLogEventSchema = z.object({
  status: AmforiSyncStepLogStatusSchema,
  code: z.string().min(1),
  message: z.string(),
  suggestedFix: z.string().optional(),
  context: z.record(z.string(), z.unknown()).optional(),
});

export type AmforiSyncStepLogEvent = z.infer<
  typeof AmforiSyncStepLogEventSchema
>;
